<template>
  <div>
    <!--水印-->
    <canvas id="my-cvs" width="150" height="150"></canvas>
  </div>
</template>

<script>
export default {
  name: 'watermark',
  props: ['markInfo'],
  data () {
    return {}
  },
  methods: {
    // 设置水印
    setWatermark () {
      var cvs = document.getElementById('my-cvs')
      const ctx = cvs.getContext('2d')
      ctx.font = '15px pingFangSC-Regular'
      ctx.fillStyle = '#dbdbdb'
      ctx.rotate(-45 * Math.PI / 180)
      ctx.fillText(this.markInfo.msg, -50, 90)
      var dataURL = cvs.toDataURL('image/png')
      document.getElementById(this.markInfo.domId).style.backgroundImage = 'url(' + dataURL + ')'
      document.getElementById(this.markInfo.domId).style.backgroundRepeat = 'repeat'
    }
  },
  mounted () {
    // 设置水印
    this.setWatermark()
  }
}
</script>

<style scoped>
#my-cvs {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/watermark.vue